import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { Modal } from "react-bootstrap";
import DefaultEditor from "react-simple-wysiwyg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import {
  duration,
  options1,
  status,
} from "../../../core/common/selectoption/selectoption";
import { TagsInput } from "react-tag-input-component";
import {
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import dragula, { Drake } from "dragula";
import "dragula/dist/dragula.css";
import { Deal, fetchAllDeals } from "../../../api/deal";
import { highlightMatch } from "../../../core/common/highlightmatch";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
const route = all_routes;
type Filters = {
  leadName: string;
  contact: string;
  owner: string[];
  status: string[];
  priority: string[];
};
const DealsKanban = () => {
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const route = all_routes;
  const [filters, setFilters] = useState<Filters>({
    leadName: "",
    contact: "",
    owner: [],
    status: [],
    priority: [],
  });

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const container1Ref = useRef<HTMLDivElement>(null);
  const container2Ref = useRef<HTMLDivElement>(null);
  const container3Ref = useRef<HTMLDivElement>(null);
  const container4Ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const containers = [
      container1Ref.current as HTMLDivElement,
      container2Ref.current as HTMLDivElement,
      container3Ref.current as HTMLDivElement,
      container4Ref.current as HTMLDivElement,
    ].filter((container) => container !== null);

    const drake: Drake = dragula(containers);
    return () => {
      drake.destroy();
    };
  }, []);
  const [deals, setDeals] = useState<Deal[]>([]);

  useEffect(() => {
    const loadDeals = async () => {
      try {
        const data = await fetchAllDeals();
        setDeals(data);
      } catch (error) {
        console.error("Error fetching deals", error);
      }
    };
    loadDeals();
  }, []);

  const uniqueOwners = useMemo(() => {
    return Array.from(
      new Set(deals.map((deal) => deal.leads?.users?.name).filter(Boolean))
    );
  }, [deals]);

  const filteredDeals = useMemo(() => {
    return deals.filter((deal) => {
      const leadNameMatch = deal.contact.company_name
        ?.toLowerCase()
        .includes(filters.leadName.toLowerCase());

      const contactMatch = deal.contact.contact_person_name
        ?.toLowerCase()
        .includes(filters.contact.toLowerCase());

      const ownerMatch =
        filters.owner.length === 0 ||
        filters.owner.includes(deal.leads?.users?.name);

      const statusMatch =
        filters.status.length === 0 || filters.status.includes(deal.status);

      const priorityMatch =
        filters.priority.length === 0 ||
        filters.priority.includes(deal.deal_priority);

      return (
        leadNameMatch &&
        contactMatch &&
        ownerMatch &&
        statusMatch &&
        priorityMatch
      );
    });
  }, [deals, filters]);

  const groupDealsByStatus = (deals: Deal[]) => {
    return deals.reduce((acc, deal) => {
      const status = (deal.status || "unknown").toLowerCase(); // normalize and fallback
      if (!acc[status]) acc[status] = [];
      acc[status].push(deal);
      return acc;
    }, {} as Record<string, Deal[]>);
  };

  const groupedDeals = groupDealsByStatus(filteredDeals);

  const statuses = ["open", "won", "lost", "closed"]; // or from your filter config

  // const containerRefs = useRef<Record<string, HTMLDivElement | null>>({
  //   open: null,
  //   won: null,
  //   lost: null,
  //   Closed: null,
  // });

  // const getContainerRef = (status: string) => (el: HTMLDivElement | null) => {
  //   containerRefs.current[status] = el;
  // };

  // useEffect(() => {
  //   const drake = dragula(
  //     Object.values(containerRefs.current).filter(Boolean) as HTMLDivElement[]
  //   );
  //   return () => drake.destroy();
  // }, []);

  return (
    <>
      <>
          <PageLoadProgressBar />
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-8">
                      <h4 className="page-title">
                        <i className="ti ti-medal text-primary me-2" />
                        Deals{" "}
                        <span className="count-title">
                          {statuses.reduce(
                            (total, status) =>
                              total + (groupedDeals[status]?.length || 0),
                            0
                          )}
                        </span>
                      </h4>
                    </div>

                    <div className="col-4 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link to={route.deals}>
                        <i className="ti ti-arrow-narrow-left" />
                        Deals
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* /Page Header */}
                {/* Filter */}
                <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-4">
                  <div className="d-flex align-items-center flex-wrap row-gap-2">
                    <div className="form-sorts dropdown me-2">
                      <Link
                        to="#"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="outside"
                      >
                        <i className="ti ti-filter-share" /> Filter
                      </Link>
                      <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-start p-3">
                        <div className="filter-set-view">
                          <div className="filter-set-head">
                            <h4>
                              <i className="ti ti-filter-share" />
                              Filter
                            </h4>
                          </div>

                          {/* Lead Name Filter */}
                          <div className="mb-3">
                            <h6 className="fw-semibold mb-2">Company Name</h6>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search company"
                              value={filters.leadName}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  leadName: e.target.value,
                                }))
                              }
                            />
                          </div>

                          {/* Contact Name Filter */}
                          <div className="mb-3">
                            <h6 className="fw-semibold mb-2">Contact Person</h6>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search contact"
                              value={filters.contact}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  contact: e.target.value,
                                }))
                              }
                            />
                          </div>

                          {/* Owner Filter */}
                          <div className="mb-3">
                            <h6 className="fw-semibold mb-2">Owner</h6>

                            {uniqueOwners.map((name) => (
                              <div key={name} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={filters.owner.includes(name)}
                                  onChange={(e) => {
                                    const updated = e.target.checked
                                      ? [...filters.owner, name]
                                      : filters.owner.filter((o) => o !== name);
                                    setFilters((prev) => ({
                                      ...prev,
                                      owner: updated,
                                    }));
                                  }}
                                />
                                <label className="form-check-label">
                                  {name}
                                </label>
                              </div>
                            ))}
                          </div>

                          {/* Status Filter */}
                          <div className="mb-3">
                            <h6 className="fw-semibold mb-2">Status</h6>

                            {["won", "open", "lost", "Closed"].map((status) => (
                              <div key={status} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={filters.status.includes(status)}
                                  onChange={(e) => {
                                    const updated = e.target.checked
                                      ? [...filters.status, status]
                                      : filters.status.filter(
                                          (s) => s !== status
                                        );
                                    setFilters((prev) => ({
                                      ...prev,
                                      status: updated,
                                    }));
                                  }}
                                />
                                <label className="form-check-label">
                                  {status.charAt(0).toUpperCase() +
                                    status.slice(1)}
                                </label>
                              </div>
                            ))}
                          </div>

                          {/* Priority Filter */}
                          <div className="mb-3">
                            <h6 className="fw-semibold mb-2">Priority</h6>

                            {["high", "medium", "low"].map((priority) => (
                              <div key={priority} className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={filters.priority.includes(priority)}
                                  onChange={(e) => {
                                    const updated = e.target.checked
                                      ? [...filters.priority, priority]
                                      : filters.priority.filter(
                                          (p) => p !== priority
                                        );
                                    setFilters((prev) => ({
                                      ...prev,
                                      priority: updated,
                                    }));
                                  }}
                                />
                                <label className="form-check-label">
                                  {priority.charAt(0).toUpperCase() +
                                    priority.slice(1)}
                                </label>
                              </div>
                            ))}
                          </div>

                          {/* Reset & Apply Buttons */}
                          <div className="d-flex justify-content-between mt-3">
                            <button
                              type="button"
                              className="btn btn-light"
                              onClick={() =>
                                setFilters({
                                  leadName: "",
                                  contact: "",
                                  owner: [],
                                  status: [],
                                  priority: [],
                                })
                              }
                            >
                              Reset
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                /* Optionally trigger side effects */
                              }}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="icon-form mb-3 mb-sm-0">
                      <span className="form-icon">
                        <i className="ti ti-search" />
                      </span>
                      <input
                        type="text"
                        className="form-control w-auto me-3"
                        placeholder="Search Company or Contact..."
                        value={filters.leadName}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            leadName: e.target.value,
                            contact: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div>
                    <ul className="d-flex align-items-center">
                      <li>
                        <div className="view-icons me-2">
                          <Link to={route.deals}>
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link to={route.dealsKanban} className="active">
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* /Filter */}

                {/* Deals Kanban */}
                <div className="d-flex overflow-x-auto align-items-start mb-4">
                  {statuses.map((status) => (
                    <div className="kanban-list-items" key={status}>
                      <div className="card contact-card">
                        <div className="card-body">
                          <h4 className="fw-semibold">
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </h4>
                          <span className="fw-medium text-default">
                            {groupedDeals[status]?.length || 0} Deals
                          </span>
                        </div>
                      </div>
                      <div className="kanban-drag-wrap pt-4">
                        {(groupedDeals[status] || []).map((deal) => (
                          <div
                            className="card kanban-card border"
                            key={deal.deal_id}
                          >
                            <div className="card-body">
                              <div className="d-block mb-3">
                                <div className="bg-purple border border-2 mb-3" />
                                <div className="d-flex align-items-center mb-3">
                                  <Link
                                    to={route.dealsDetails}
                                    className="avatar avatar-lg bg-gray flex-shrink-0 me-2"
                                  >
                                    <span className="avatar-title text-dark">
                                      {(deal.contact?.company_name || "NA")
                                        .slice(0, 2)
                                        .toUpperCase()}
                                    </span>
                                  </Link>
                                  <h6 className="fw-medium">
                                    <Link to={route.dealsDetails}>
                                      {highlightMatch(
                                        deal.contact?.company_name || "N/A",
                                        filters.leadName.toLowerCase()
                                      )}
                                    </Link>
                                  </h6>
                                </div>
                              </div>

                              {/* Deal Value */}
                              <p className="text-default mb-2">
                                <i className="ti ti-report-money text-dark me-1" />
                                {highlightMatch(
                                  `${deal.currency || "₹"} ${
                                    deal.deal_value || "0"
                                  }`,
                                  filters.leadName.toLowerCase()
                                )}
                              </p>

                              {/* Contact Email */}
                              <p className="text-default mb-2">
                                <i className="ti ti-mail text-dark me-1" />
                                {highlightMatch(
                                  deal.contact?.company_mail || "N/A",
                                filters.contact
                                    .toLowerCase()  
                                )}
                              </p>

                              {/* Owner */}
                              <p className="text-default mb-2">
                                <i className="ti ti-user text-dark me-1" />
                                Owner:{" "}
                                {highlightMatch(
                                  deal.leads?.users?.name || "-",
                                 filters.owner.join(", ")
                                )}
                              </p>

                              {(() => {
                                const priority = (
                                  deal.deal_priority || "Low"
                                ).toLowerCase();
                                const priorityConfig: Record<
                                  string,
                                  {
                                    percent: number;
                                    color: string;
                                    icon: string;
                                  }
                                > = {
                                  high: {
                                    percent: 90,
                                    color: "bg-danger",
                                    icon: "ti ti-alert-triangle",
                                  },
                                  medium: {
                                    percent: 60,
                                    color: "bg-warning",
                                    icon: "ti ti-flag",
                                  },
                                  low: {
                                    percent: 30,
                                    color: "bg-success",
                                    icon: "ti ti-arrow-down-circle",
                                  },
                                };

                                const config =
                                  priorityConfig[priority] ||
                                  priorityConfig["low"];

                                return (
                                  <>
                                    <p className="text-default mb-3">
                                      <i
                                        className={`${config.icon} text-dark me-1`}
                                      />
                                      Priority:{" "}
                                      {highlightMatch(
                                        deal.deal_priority || "-",
                                        filters.priority.join(", ")
                                      )}
                                    </p>

                                    {/* Progress Bar */}
                                    <div className="mb-3">
                                      <label className="form-label text-default d-flex justify-content-between">
                                        <span>Priority</span>
                                        <span>{config.percent}%</span>
                                      </label>
                                      <div
                                        className="progress"
                                        style={{ height: "8px" }}
                                      >
                                        <div
                                          className={`progress-bar ${config.color}`}
                                          style={{
                                            width: `${config.percent}%`,
                                          }}
                                          role="progressbar"
                                          aria-valuenow={config.percent}
                                          aria-valuemin={0}
                                          aria-valuemax={100}
                                        />
                                      </div>
                                    </div>
                                  </>
                                );
                              })()}

                              {/* Due Date */}
                              <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                                <p className="text-default mb-0">Due date</p>
                                <span className="text-muted">
                                  <i className="ti ti-calendar-due me-1" />
                                  {new Date(deal.due_date).toLocaleDateString()}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                {/* /Deals Kanban */}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </>
  );
};

export default DealsKanban;
